module.exports = __webpack_public_path__ + "static/media/temp-foto-hero-1.db336b08.jpg";